import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./fonts/sharpgrotesk-medium20-webfont.woff";
import "./fonts/sharpgrotesk-medium20-webfont.woff2";

//import * as serviceWorker from './serviceWorker';
import { HashRouter } from "react-router-dom";
import ScrollToTop from "./ScrollToTop";
import { AppProvider } from "./AppContext";

ReactDOM.render(
    <HashRouter>
        <ScrollToTop>
            <AppProvider>
                <App />
            </AppProvider>
        </ScrollToTop>
    </HashRouter>,
    document.getElementById("root")
);
